import request from "@/utils/request";

// 日下单量直线图
export async function GetComHomeDailyOrderCount(params) {
  return request({
    url: "/Home/GetComHomeDailyOrderCount",
    method: "get",
    params: params,
  });
}

// 服务项目下单排行
export async function GetComHomeServiceTop(params) {
  return request({
    url: "/Home/GetComHomeServiceTop",
    method: "get",
    params: params,
  });
}

// 营收折线图统计
export async function GetComHomeDailyAmount(params) {
  return request({
    url: "/Home/GetComHomeDailyAmount",
    method: "get",
    params: params,
  });
}

//服务商首页数据汇总
export async function GetComHomeData(params) {
  return request({
    url: "/Home/GetComHomeData",
    method: "get",
    data: params,
  });
}
